import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UiMessageCodeHelpers from 'shared/utils/UiMessageCodeHelpers';
import { BLUE, WHITE } from '../../Styles';
import { StyledButton } from '../Styles';

export const EnableClerkDebuggingButton = observer(() => {
  const {
    AuctionStore: { getAuctionLaneIdForInvocation },
    BidStore: {
      auction: { monitorChatOnly },
    },
    WebSocketStore: { sendMessage },
  } = useStores();

  if (!monitorChatOnly) return null;

  return (
    <StyledButton
      bgColor={BLUE}
      color={WHITE}
      onClick={() => {
        sendMessage({
          method: 'UiMessageToClerks',
          payload: [
            getAuctionLaneIdForInvocation,
            UiMessageCodeHelpers.getUiStateResult(
              UiMessageCodeHelpers.uiMessageState.DebuggingErrorsOn,
            ).value,
          ],
        });
      }}
      style={{ cursor: 'pointer' }}
    >
      Remote Debugging On
    </StyledButton>
  );
});

export default EnableClerkDebuggingButton;
